import React, { useState } from "react"
import { useDispatch } from "react-redux"
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { detachDistributionCenter } from "../../../../actions/Organizations/Enterprise"

const sx = {
  dialog: {
    "& .MuiDialog-paper": {
      width: 560,
      maxWidth: 480,
      borderRadius: "12px",
    },
  },
  title: {
    px: 4,
    pt: 3,
    pb: 1,
    fontSize: 20,
    fontWeight: 400,
    pr: 7,
    marginBottom: "30px !important",
  },
  closeBtn: {
    position: "absolute",
    right: 16,
    top: 16,
    color: "text.secondary",
  },
  content: {
    px: 4,
    pt: 1,
    pb: 2,
  },
  serverError: {
    px: 4,
    pb: 1,
    fontSize: 14,
    color: "error.main",
  },
  actions: {
    px: 4,
    py: 2.5,
    justifyContent: "flex-end",
    gap: 1.5,
    borderTop: "1px solid",
    borderColor: "divider",
  },
}

const DetachDCConfirmModal = ({ open, onClose, enterpriseId, link }) => {
  const dispatch = useDispatch()
  const [isSubmitting, setSubmitting] = useState(false)
  const [serverError, setServerError] = useState(null)

  const handleClose = () => {
    if (isSubmitting) return
    setServerError(null)
    onClose()
  }

  const handleConfirm = async () => {
    setSubmitting(true)
    setServerError(null)
    try {
      await dispatch(detachDistributionCenter(enterpriseId, link.dc?.objectId))
      onClose()
    } catch {
      setServerError("Une erreur est survenue, veuillez réessayer")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} sx={sx.dialog}>
      <DialogTitle sx={sx.title}>
        Désactiver ce site ?
        <IconButton onClick={handleClose} disabled={isSubmitting} sx={sx.closeBtn}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={sx.content}>
        <Typography variant="body2" sx={{ color: "text.primary", fontSize: 14, lineHeight: 1.5 }}>
          Le site <Box component="strong" sx={{ fontWeight: 500 }}>{link.dcName}</Box>
          {link.dcCode ? ` (${link.dcCode})` : ""} sera désactivé pour cette entreprise.
          Les commandes futures ne pourront pas y être affectées.
        </Typography>
      </DialogContent>

      {serverError && (
        <Typography sx={sx.serverError}>{serverError}</Typography>
      )}

      <DialogActions sx={sx.actions}>
        <Button variant="text" onClick={handleClose} disabled={isSubmitting}>
          Annuler
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleConfirm}
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {isSubmitting ? "…" : "Désactiver"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DetachDCConfirmModal
